/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Collection page: "Sýna meira" (show more) loads the next page automatically when it scrolls into view,
 * and appends the products to the current grid. Clicking the button does the same. Works again after the
 * theme reloads the product grid (filters, sorting, products per page).
 */
(function () {
  var loading = false;
  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function load(container) {
    if (loading || !container || !container.isConnected) return;
    var link = container.querySelector('[data-load-more-link]');
    var root = container.closest('[data-section-type="collection"]');
    var list = root && root.querySelector('.product-list--collection');
    if (!link || !list) return;

    loading = true;
    container.style.opacity = '0.5';
    link.setAttribute('aria-busy', 'true');

    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));

    // Ask for just the section; if Shopify can't render it (404), fetch the whole next page instead.
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response : fetch(link.href, { credentials: 'same-origin' });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var newList = temp.querySelector('.product-list--collection');
        if (newList) {
          while (newList.firstElementChild) list.appendChild(newList.firstElementChild);
        }

        var showing = temp.querySelector('[data-load-more-showing]');
        if (showing) {
          root.querySelectorAll('.collection__showing-count').forEach(function (el) { el.textContent = showing.textContent; });
        }

        var next = temp.querySelector('[data-load-more]');
        if (next) container.replaceWith(next); else container.remove();
        loading = false;
        scan();
        checkNear();
      })
      .catch(function () {
        loading = false;
        window.location.href = link.href;
      });
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) load(entry.target);
    });
  }, { rootMargin: '0px 0px 600px 0px' }) : null;

  function scan() {
    if (!observer) return;
    document.querySelectorAll('[data-load-more]').forEach(function (el) {
      if (seen) {
        if (seen.has(el)) return;
        seen.add(el);
      }
      observer.observe(el);
    });
  }

  // Also load when the button is near or above the viewport, so a fast jump to the bottom (End key, scrollbar drag)
  // that skips past the button still triggers it.
  function checkNear() {
    document.querySelectorAll('[data-load-more]').forEach(function (el) {
      if (el.offsetParent !== null && el.getBoundingClientRect().top - window.innerHeight < 600) load(el);
    });
  }

  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () { scrollTicking = false; checkNear(); });
  }, { passive: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-load-more-link]');
    if (!link) return;
    event.preventDefault();
    load(link.closest('[data-load-more]'));
  });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();

/**
 * Never show a "0 kr" price in Rapid Search results or its search dropdown (zero-price products are quote-only).
 * The app renders its own markup in the browser, so prices are checked whenever it changes the page.
 */
(function () {
  var ZERO = /^0\s*kr\.?$/i;

  function hideZeroPrices() {
    document.querySelectorAll('[class*="rps"] [class*="price"]').forEach(function (el) {
      if (el.children.length === 0 && ZERO.test(el.textContent.trim())) el.style.display = 'none';
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; hideZeroPrices(); });
  }

  function init() {
    hideZeroPrices();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();